import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { IDropTypeData } from "../DropTypes.types";

export const useAddDropTypeViewModel = ({
  goBack = () => null,
  reset = () => null,
}: IUseAddDropTypeViewModelProps = {}) => {
  const stateManager = useComponentState();

  const fetchDropTypeDetails = async (id: string) => {
    const response = await stateManager.run(() => {
      return homeService.dropTypes.getById({ id });
    });
    if (response.status === HTTP_STATUSES.OK) {
      reset(response.data);
    }
  };

  const handleCreateDropType = async (data: IDropTypeData) => {
    const response = await stateManager.run(() => {
      return homeService.dropTypes.create({
        data,
        toastMessageConfig: {
          success: {
            text: `Successfully created Drop Type: ${data.name}.`,
          },
        },
      });
    });
    if (response.status === HTTP_STATUSES.OK) {
      goBack();
    }
  };

  const handleUpdateDropType = async (data: IDropTypeData) => {
    const response = await stateManager.run(() => {
      return homeService.dropTypes.update({
        id: data.id,
        data,
        modifiedOn: data.modifiedOn,
        toastMessageConfig: {
          success: {
            text: `Successfully updated Drop Type: ${data.name}.`,
          },
        },
      });
    });
    if (response.status === HTTP_STATUSES.OK) {
      goBack();
    }
  };

  return {
    isLoading: stateManager.isBusy(),
    fetchDropTypeDetails,
    handleCreateDropType,
    handleUpdateDropType,
  };
};

interface IUseAddDropTypeViewModelProps {
  goBack?: () => void;
  reset?: (data: IDropTypeData) => void;
}
